document.addEventListener('DOMContentLoaded', () => {

  // ============================================
  // Background Videos
  // Homepage Desktop / Mobile
  // ============================================

  const backgroundToggles = document.querySelectorAll(
    '.video-background .video-toggle'
  );

  backgroundToggles.forEach((button) => {
    const wrapper = button.closest('.video-background');
    const video = wrapper?.querySelector('video');

    if (!video) return;

    const updateButton = () => {
      if (video.paused) {
        button.textContent = 'Play';
        button.setAttribute('aria-label', 'Play video');
      } else {
        button.textContent = 'Pause';
        button.setAttribute('aria-label', 'Pause video');
      }
    };

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch((error) => {
          console.error('Video could not be played:', error);
        });
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);

    updateButton();
  });


  // ============================================
  // Open Day Hero Video
  // ============================================

  const heroVideo = document.getElementById('heroVideo');

  const heroButton = document.querySelector(
    '.video-wrapper .video-toggle[aria-controls="heroVideo"]'
  );

  if (heroVideo && heroButton) {

    const updateHeroButton = () => {
      if (heroVideo.paused) {
        heroButton.textContent = 'Play';
        heroButton.setAttribute('aria-label', 'Play video');
      } else {
        heroButton.textContent = 'Pause';
        heroButton.setAttribute('aria-label', 'Pause video');
      }
    };

    heroButton.addEventListener('click', () => {
      if (heroVideo.paused) {
        heroVideo.play().catch((error) => {
          console.error('Video could not be played:', error);
        });
      } else {
        heroVideo.pause();
      }
    });

    heroVideo.addEventListener('play', updateHeroButton);
    heroVideo.addEventListener('pause', updateHeroButton);

    updateHeroButton();
  }

});